import styled from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";

export const UserPhotoContainer = styled.div`
  position: relative;
  height: fit-content;

  .icon {
    position: absolute;
    right: 0;
    bottom: -12px;
  }

  img {
    border-radius: 50%;
  }

  ${SimpleUserInitialsNameContainer} {
    width: 32px;
    height: 32px;

    h1 {
      font: 400 0.875rem / 1.5rem "Inter" !important;
    }
  }
`;
